import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  INSTANT_WIN_CAMPAIGN_PATH,
  INSTANT_WIN_CAMPAIGN_ADD_PATH,
  INSTANT_WIN_CAMPAIGN_UPDATE_PATH,
} from "utils/constants/paths";

const InstantWinCampaign = Loadable(React.lazy(() => import("./View")));
const InstantWinCampaignAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const InstantWinCampaignRoute: IRouteItem = {
  path: INSTANT_WIN_CAMPAIGN_PATH,
  iconName: "Flashy",
  element: React.createElement(InstantWinCampaign),
  name: "Campaigns",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: INSTANT_WIN_CAMPAIGN_ADD_PATH,
      element: React.createElement(InstantWinCampaignAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: INSTANT_WIN_CAMPAIGN_UPDATE_PATH,
      element: React.createElement(InstantWinCampaignAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
